import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { CrmType } from "../../../constants/ComponentTypes";
import Button from "../../Parts/Button";
import IntegrationInquiryDialog from "./IntegrationInquiryDialog";
import HelpIcon from '../../Icons/HelpIcon';
import Tooltip from 'material-ui/Tooltip';
import { isFreePlan } from '../../../utils/planUtils';

const Crms = [
  {
    title: "HubSpotと連携",
    desc:
      "HubSpotリストをKeyman Letterに同期して、HubSpotのコンタクトにレターを送付したり、タイムラインでステータス管理できます。",
    type: CrmType.HUBSPOT,
    name: "Hubspot",
    value: "hubspot",
    logoPath: require("../../../assets/images/hubspot-logo.svg"),
  },
  {
    title: "Salesforceと連携",
    desc:
      "SalesforceリストをKeyman Letterに同期して、Salesforceのレコードにレターを送付したり、タイムラインでステータス管理できます。",
    type: CrmType.SALESFORCE,
    name: "Salesforce",
    value: "salesforce",
    logoPath: require("../../../assets/images/salesforce-logo.svg"),
    url: process.env.REACT_APP_API_BASE_URL + "/oauth2/salesforce",
  },
  {
    title: "Oktaと連携",
    desc:
      "Keyman LetterとOktaを連携することで、メールアドレスとパスワードを入力することなしにOktaから簡単にKeyman Letterにログインすることができるようになります。",
    type: CrmType.MARKETO,
    name: "Okta",
    value: "Okta",
    logoPath: require("../../../assets/images/okta-logo.svg"),
  },
];

const styles = () => ({
  container: {
    marginTop: "50px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },

  crmContainer: {
    width: "33.33%",
    height: "100%",
  }
});

const boxStyles = () => ({
  root: {
    border: "1px solid #E7E9EB",
    display: "flex",
    flexDirection: "column",
    margin: "0px 6px",
    height: "100%",
    position: "relative"
  },

  logoContainer: {
    height: "210px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #E7E9EB",
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 26px",
    boxSizing: "border-box",
  },

  titleContainer: {
    display: "flex",
  },

  title: {
    fontSize: "16px",
    fontWeight: "bold",
  },

  tooltip: {
    maxWidth: '335px',
    backgroundColor: "#181819",
    padding: '12px 15px',
    opacity: 1,
    textAlign: 'left',
  },

  tooltipRoot: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center'
  },

  arrow: {
    position: 'absolute',
    fontSize: 6,
    bottom: 0,
    left: 'calc(50% - 1.5em)',
    marginBottom: '-0.95em',
    width: '3em',
    height: '1em',

    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '1em 1em 0 1em',
      borderColor: `#181819 transparent transparent transparent`,
    },
  },

  desc: {
    margin: "15px 0px 60px 0px",
    fontSize: "12px",
    flex: 1,
  },

  img: {
    maxHeight: "160px",
    maxWidth: "65%",
  },
});

const Box = withStyles(boxStyles)(
  ({
    classes,
    key,
    logo,
    title,
    desc,
    url,
    tooltip,
    integrationStatus,
    goTo,
    integrationFlag,
    isFreePlan,
    togglePlanDialog,
    toggleInquiryDialog,
    style = {},
  }) => {
    return (
      <div className={classes.root} style={style} key={key}>
        <div className={classes.logoContainer}>
          <img src={logo} alt={title} className={classes.img} />
        </div>
        <div className={classes.textContainer}>
          <div className={classes.titleContainer}>
            <Typography className={classes.title} variant="subheading">
              {title}
            </Typography>
            {tooltip && (
              <Tooltip
                placement="top"
                title={
                  <React.Fragment>
                    {tooltip}
                    <span className={classes.arrow} />
                  </React.Fragment>
                }
                classes={{
                  tooltip: classes.tooltip,
                  root: classes.tooltipRoot,
                }}
              >
                <HelpIcon width={20} height={20} color="#B1B3B9" />
              </Tooltip>
            )}
          </div>
          <div className={classes.desc}>{desc}</div>
          {(() => {
            let action;

            if (isFreePlan) {
              return (
                <Button
                  text="連携"
                  disabled={!url}
                  handleClickButton={togglePlanDialog}
                  style={{
                    position: "absolute",
                    bottom: 20
                  }}
                />
              );
            } else if (integrationStatus) {
              if (integrationFlag) {
                action = () => goTo("/setting/integrations/salesforce");
              } else {
                action = toggleInquiryDialog;
              }
              return (
                <Button
                  text="設定"
                  type="line"
                  disabled={!url}
                  handleClickButton={action}
                  style={{
                    position: "absolute",
                    bottom: 20
                  }}
                />
              );
            } else {
              if (integrationFlag) {
                action = () => window.open(url, "_self");
              } else {
                action = toggleInquiryDialog;
              }
              return (
                <Button
                  text="連携"
                  disabled={!url}
                  handleClickButton={action}
                  style={{
                    position: "absolute",
                    bottom: 20
                  }}
                />
              );
            }
          })()}
        </div>
      </div>
    );
  }
);

class IntegrationPanel extends React.Component {
  state = {
    showInquiryDialog: false,
  };

  toggleInquiryDialog = () => {
    this.setState({ showInquiryDialog: !this.state.showInquiryDialog });
  };

  renderInquiryDialog = () => {
    if (this.state.showInquiryDialog) {
      return (
        <IntegrationInquiryDialog
          isOpen={this.state.showInquiryDialog}
          toggleDialog={this.toggleInquiryDialog}
        />
      );
    }
  };

  render() {
    const { classes, integrations, salesforceImportMapping, user } = this.props;

    return (
      <div className={classes.container}>
        {Crms.map((crm, i) => (
          <div key={i} className={classes.crmContainer}>
            <Box
              isFreePlan={isFreePlan(user)}
              togglePlanDialog={this.props.togglePlanDialog}
              toggleInquiryDialog={this.toggleInquiryDialog}
              key={i}
              tooltip={crm.value === "salesforce" ? "連携はSalesforce Enterprise Editionのみ可能です。" : null}
              title={crm.title}
              desc={crm.desc}
              logo={crm.logoPath}
              integrationFlag={
                crm.value === "salesforce" && user.salesforce_integration_flag
              }
              integrationStatus={integrations && integrations[crm.value]}
              url={crm.url}
              goTo={this.props.goTo}
              mappingExists={(() => {
                if (crm.type === CrmType.SALESFORCE) {
                  return !!salesforceImportMapping;
                } else {
                  return false;
                }
              })()}
            />
          </div>
        ))}
        {this.renderInquiryDialog()}
      </div>
    );
  }
}

IntegrationPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  integrations: PropTypes.object,
  removeCrm: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  user: PropTypes.object,
  salesforceImportMapping: PropTypes.object,
  togglePlanDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(IntegrationPanel);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Integration/IntegrationPanel.jsx